import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "components/ui/button";
import { cn } from "../../../../../util/cn";

interface Props {
  to?: string;
  onNext?: () => void;
  enabled?: boolean;
  bounceKey?: string | number | null;
}

const KeyHandoverNavigateNextAction: React.FC<Props> = ({ to, onNext, enabled = true, bounceKey = null }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const [pulsing, setPulsing] = React.useState(false);
  React.useEffect(() => {
    if (bounceKey == null) return;
    if (!enabled) return;
    setPulsing(true);
    const tmr = setTimeout(() => setPulsing(false), 250);
    return () => clearTimeout(tmr);
  }, [bounceKey, enabled]);

  const onClick = () => {
    if (!enabled) return;
    if (onNext) {
      onNext();
    } else if (to) {
      navigate({ pathname: to, search: location.search });
    }
  };

  return (
    <Button
      size="lg"
      variant="primary"
      className={cn("w-full transition-all duration-300 ease-out will-change-transform", pulsing && "scale-[1.03]")}
      disabled={!enabled}
      onClick={onClick}
    >
      {t("book_location.next")}
    </Button>
  );
};

export default KeyHandoverNavigateNextAction;
